module.exports = __webpack_public_path__ + "assets/img/37_1491_big.f33423ed.jpg";